module.exports = __webpack_public_path__ + "static/media/uz.01443643.png";